import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SectionType, Section } from "pages/application/applicationService";
import { SectionProgressState } from "./SectionBar";

interface SectionBarDropdownProps {
    activeSection: SectionType;
    isDropdownOpen: boolean;
    onToggle: () => void;
    getSectionIndex: (sectionCode: string) => number;
    getSectionDisplayName: (sectionCode: string) => string;
    getSectionDescription: (sectionCode: string) => string | undefined;
    sections: Section[];
    getSectionState: (activeSection: string, section: Section) => SectionProgressState;
}

export const SectionBarDropdown = ({
    activeSection,
    isDropdownOpen,
    onToggle,
    getSectionIndex,
    getSectionDisplayName,
    getSectionDescription,
    sections,
    getSectionState
}: SectionBarDropdownProps) => {
    const currentSection = sections.find(section => section.sectionCode === activeSection);
    const currentState = currentSection ? getSectionState(activeSection, currentSection) : SectionProgressState.NotStarted;

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onToggle();
        }
    };

    const getIconElement = (state: SectionProgressState) => {
        if (state === SectionProgressState.Completed) {
            return (
                <FontAwesomeIcon
                    icon={solid("check-circle")}
                    className="section-bar__dropdown-card__content__title__icon--completed"
                />
            );
        } else {
            return (
                <FontAwesomeIcon
                    icon={solid("circle")}
                    className="section-bar__dropdown-card__content__title__icon"
                />
            );
        }
    };

    const getDropdownClassName = (state: SectionProgressState) => {
        if (state === SectionProgressState.Completed) {
            return "section-bar__dropdown-card__content--completed";
        } else {
            return "";
        }
    };

    return (
        <button
            type="button"
            className={`section-bar__dropdown-card ${isDropdownOpen ? 'section-bar__dropdown-card--open' : ''}`}
            onClick={onToggle}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            aria-expanded={isDropdownOpen}
            aria-label={`Toggle section dropdown for ${getSectionDisplayName(activeSection)}`}
        >
            <div className={`section-bar__dropdown-card__content ${getDropdownClassName(currentState)}`}>
                <span className="section-bar__dropdown-card__content__title">
                    {getIconElement(currentState)}
                    <span className="section-bar__dropdown-card__content__title__name">
                        {`${getSectionIndex(activeSection)}. ${getSectionDisplayName(activeSection)}`}
                    </span>
                </span>
                <span className="section-bar__dropdown-card__content__title__description">
                    {getSectionDescription(activeSection)}
                </span>
            </div>
            <FontAwesomeIcon
                icon={solid("chevron-down")}
                className={`section-bar__dropdown-card__content__dropdown-arrow ${isDropdownOpen ? 'section-bar__dropdown-card__content__dropdown-arrow--open' : ''}`}
            />
        </button>
    );
};